import { observer } from "mobx-react-lite";
import { useStores } from "stores";
import { CustomButton } from "ui";
import { BID_REQUEST_STATUS_ENUM } from "interfaces";
import { confirmationModalConfigs, ConfirmationModal } from "components/ActionModals/ConfirmationModal";
import { stepBack } from "services";

export const StepBackButton = observer(() => {
  const { actionModals, bidCard } = useStores();
  const { id } = bidCard.bid;

  const texts = getTexts(bidCard.bid.status);

  const stepBackHandler = () => {
    actionModals.open(
      () => (
        <ConfirmationModal
          text={texts.modalText}
          buttonText={texts.buttonText}
          calledQuery={() => stepBack({ id })}
          // onSuccess={() => {
          //   setTimeout(() => {
          //     window.updateOnboardingElements?.();
          //   }, 1000);
          // }}
        />
      ),
      {
        ...confirmationModalConfigs,
        onClose: () => actionModals.closeAll(),
      }
    );
  };

  return (
    <CustomButton id={texts.id ?? undefined} type="default" onClick={stepBackHandler} tooltip={texts.buttonTooltip}>
      {texts.buttonText}
    </CustomButton>
  );
});

const getTexts = (status: string) => {
  switch (status) {
    case BID_REQUEST_STATUS_ENUM.AGENT_PROPOSAL_ACCEPTED:
      return {
        modalText: "Вы действительно хотите исправить документы? Заявка вернется в предыдущий статус",
        buttonText: "Исправить документы",
        buttonTooltip: "Заявка вернется в предыдущий статус для исправления документов",
      };
    case BID_REQUEST_STATUS_ENUM.EXPIRED:
      return {
        modalText: "Вы действительно хотите вернуть заявку в предыдущий статус?",
        buttonText: "Запросить снова",
        buttonTooltip: "Вернуться на шаг сбора котировок",
      };
    default:
      return {
        id: status === BID_REQUEST_STATUS_ENUM.QUOTE_PROPOSED ? "cancel-bid-quote-proposed-button" : undefined,
        modalText: "Вы действительно хотите отклонить условия?",
        buttonText: "Отклонить условия",
        buttonTooltip: "Заявка вернется в предыдущий статус для изменения условий",
      };
  }
};
